import { render, staticRenderFns } from "./formText.vue?vue&type=template&id=303c9a19&"
import script from "./formText.vue?vue&type=script&lang=js&"
export * from "./formText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports